import { render, staticRenderFns } from "./MobileAccordion.vue?vue&type=template&id=3b375cec&"
import script from "./MobileAccordion.vue?vue&type=script&lang=js&"
export * from "./MobileAccordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/lifecheq/htdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b375cec')) {
      api.createRecord('3b375cec', component.options)
    } else {
      api.reload('3b375cec', component.options)
    }
    module.hot.accept("./MobileAccordion.vue?vue&type=template&id=3b375cec&", function () {
      api.rerender('3b375cec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Calculators/MyCover/Summaries/MobileAccordion.vue"
export default component.exports